'use client'
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Flex } from '@chakra-ui/layout';
import { FormControl, FormErrorMessage, Input } from '@chakra-ui/react';
import { IconButton } from '@chakra-ui/button';
import { MdCheck } from 'react-icons/md';
import { forwardRef } from '@chakra-ui/system';
import { useSharedExperiencesApi } from '../lib/useSharedExperiencesApi';
const SharedExperienceForm = forwardRef((props, ref) => {
  const {
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting,
  } = props;
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting, isValid }
  } = useForm({
    mode: 'onChange'
  });
  const sharedExperiencesApi = useSharedExperiencesApi();
  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const name = data.name;
      let newSharedExperience;
      if (name) {
        newSharedExperience = await sharedExperiencesApi.createSharedExperience({ name });
      }
      if (onSubmitted) {
        onSubmitted(newSharedExperience);
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)} >
          <Flex
            alignItems={'center'}
          >
            <FormControl isInvalid={errors && errors.name}>
              <Input
                placeholder='Name'
                {...register('name', {
                  required: true,
                  minLength: 3
                })}
              />
              <FormErrorMessage>{errors && errors.name}</FormErrorMessage>
            </FormControl>
            <IconButton
              style={{
                display: hideSave ? 'none' : 'inherit',
              }}
              ref={ref}
              icon={<MdCheck />}
              ml={2}
              type={'submit'}
              aria-label='check'
              variant='primary'
              isLoading={isSubmitting}
              isDisabled={!isValid}
            />
          </Flex>
        </form>
      </Box>
    </>
  );
});
export default SharedExperienceForm; 